import { throttle } from '@/core';
import { getClerksRequest } from '../requests';

async function getClerks({ state, commit }) {
	try {
		if (state.clerks.length === 0) {
			await fetchClerks();
		} else {
			await throttle(fetchClerks, 'fetchClerks', 60 * 1000);
		}
	} catch (err) {
		console.log(`Set clerks failed: ${ err }`);
	}

	async function fetchClerks() {
		let response = await getClerksRequest();
		commit('setClerks', response);
	}
}

export default { getClerks };
